import { Button, Theme } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NewbuildingPurchaseGiftGallerySlide.css';
import heroImageUrl from './assets/hero.png';

export interface INewbuildingPurchaseGiftGallerySlideProps {
  buttonText: string;
  onClick(): void;
}

/**
 * Слайд акции «30 000 ₽ за покупку квартиры» в галерее новостроечной карточки.
 * Рендерится и в обычной, и в полноэкранной галерее.
 * Реф на корень нужен ActionAfterViewObserver без обёртки.
 */
export const NewbuildingPurchaseGiftGallerySlide = React.forwardRef<
  HTMLDivElement,
  INewbuildingPurchaseGiftGallerySlideProps
>(({ buttonText, onClick }, ref) => {
  return (
    <div ref={ref} className={styles['container']} data-testid="NewbuildingPurchaseGiftGallerySlide">
      <img
        className={styles['hero']}
        src={heroImageUrl}
        width="386"
        height="170"
        alt="Получите 30 000 ₽ за звонок через Циан"
      />
      <Theme theme="colored">
        <Button theme="main_secondary" size="M" afterIcon={<IconActionChevronRightSmall16 />} onClick={onClick}>
          {buttonText}
        </Button>
      </Theme>
    </div>
  );
});

NewbuildingPurchaseGiftGallerySlide.displayName = 'NewbuildingPurchaseGiftGallerySlide';
